import AxiosJob from '@/services/api/job/axios_job'

export default {
  saveBatchDeliverable: (data) => {
    return AxiosJob.post('/deliverable/batch-save', data)
  },

  getJobDeliverables: (jobId) => {
     return AxiosJob.get(`deliverable/batch-read/${jobId}`)
  },
}
